type ChartAccessInput = {
  hasProfile: boolean
  hasChartAccess: boolean
}

// Only block once the profile has answered, so a direct link is not bounced while it loads.
export const isChartsRouteBlocked = ({ hasProfile, hasChartAccess }: ChartAccessInput): boolean =>
  hasProfile && !hasChartAccess
